var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zlDiscuss" }, [
    !_vm.showEditor && !_vm.showDetails
      ? _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.discussLoading,
                expression: "discussLoading"
              }
            ],
            staticClass: "discuss_list_wrap"
          },
          [
            _vm.discussList && _vm.discussList.length > 0
              ? _c(
                  "div",
                  { staticClass: "discuss_tab" },
                  _vm._l(_vm.tabList, function(item, index) {
                    return _c(
                      "p",
                      {
                        key: index,
                        staticClass: "discuss_tab_p",
                        class: { activeStyle: _vm.type === index },
                        on: {
                          click: function($event) {
                            return _vm.activeThis(index)
                          }
                        }
                      },
                      [_vm._v("\n        " + _vm._s(item) + "\n      ")]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.discussList && _vm.discussList.length > 0
              ? _c(
                  "div",
                  { staticClass: "discussListBox" },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "margin-bottom": "10px",
                          "align-items": "center",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("el-switch", {
                          attrs: {
                            "inactive-text": "查看全部",
                            "active-text": "只看我的"
                          },
                          on: { change: _vm.getNoteList },
                          model: {
                            value: _vm.myContent,
                            callback: function($$v) {
                              _vm.myContent = $$v
                            },
                            expression: "myContent"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function($event) {
                                _vm.showEditor = true
                              }
                            }
                          },
                          [_vm._v("发起讨论")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.discussList, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "discuss_item",
                          on: {
                            click: function($event) {
                              return _vm.getDiscussionAndReply(item)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "head_portrait" }, [
                            item.userType == 0
                              ? _c("img", { attrs: { src: _vm.teacherHead } })
                              : item.userType == 1
                              ? _c("img", { attrs: { src: _vm.teacherHead } })
                              : item.userType == 2
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      item.anonymous == 0
                                        ? _vm.anonymousHead
                                        : _vm.studentHead
                                  }
                                })
                              : _c("img", { attrs: { src: _vm.anonymousHead } })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "list_info" }, [
                            _c("div", { staticClass: "list_info_line" }, [
                              _c("div", { staticClass: "list_info_line_box" }, [
                                _c("span", { staticClass: "user_name" }, [
                                  _vm._v(
                                    _vm._s(
                                      item.anonymous == 0
                                        ? "匿名用户"
                                        : item.userName
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "list_info_line_box" }, [
                                item.userType == 0 || item.userType == 1
                                  ? _c("span", { staticClass: "user_type" }, [
                                      _vm._v("教师")
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "list_info_line_box" }, [
                                _c("span", { staticClass: "time" }, [
                                  _vm._v(_vm._s(item.createTimeStr))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "list_info_line_box" }, [
                                item.repliedOrParticipation
                                  ? _c("span", { staticClass: "status" }, [
                                      _vm._v(
                                        _vm._s(item.repliedOrParticipationName)
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "list_info_line" }, [
                              _c("p", [_vm._v(_vm._s(item.theme))])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "list_info_line" }, [
                              item.catalogId != "" && item.discussionAreaId != 3
                                ? _c("div", { staticClass: "chapter" }, [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "/static/images/study/icon/zhangjie.png"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          item.catalogId != null
                                            ? item.catalogName
                                            : "全部教学章节"
                                        )
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "operation" }, [
                                item.createUser === Number(_vm.userId)
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "operation_item",
                                        attrs: { title: "编辑" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.getDiscussionToEdt(item)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass: "icon svg-icon",
                                            staticStyle: {
                                              width: "14px",
                                              height: "14px"
                                            },
                                            attrs: { "aria-hidden": "true" }
                                          },
                                          [
                                            _c("use", {
                                              attrs: {
                                                "xlink:href": "#icon-xiugai"
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "operation_item",
                                    attrs: { title: "浏览" }
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "icon svg-icon",
                                        staticStyle: {
                                          width: "14px",
                                          height: "14px"
                                        },
                                        attrs: { "aria-hidden": "true" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#icon-liulan"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          item.viewCount &&
                                            item.viewCount !== "null"
                                            ? item.viewCount
                                            : 0
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "operation_item",
                                    attrs: { title: "点赞" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.discussionSamePraise(item)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "icon svg-icon",
                                        staticStyle: {
                                          width: "14px",
                                          height: "14px"
                                        },
                                        attrs: { "aria-hidden": "true" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#icon-dianzan"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          item.praiseCount &&
                                            item.praiseCount !== "null"
                                            ? item.praiseCount
                                            : 0
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "operation_item",
                                    attrs: { title: "消息" }
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "icon svg-icon",
                                        staticStyle: {
                                          width: "14px",
                                          height: "14px"
                                        },
                                        attrs: { "aria-hidden": "true" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#icon-xiaoxi"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          item.replyCount &&
                                            item.replyCount !== "null"
                                            ? item.replyCount
                                            : 0
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          item.roofPlacement
                            ? _c("div", { staticClass: "is_top" }, [
                                _c("img", {
                                  attrs: {
                                    src: "/static/images/study/icon/zhiding.png"
                                  }
                                })
                              ])
                            : _vm._e()
                        ]
                      )
                    })
                  ],
                  2
                )
              : _c(
                  "div",
                  { staticClass: "isEmpty" },
                  [
                    _c(
                      "el-empty",
                      { attrs: { "image-size": 100, description: " " } },
                      [
                        _c("p", [
                          _vm._v("暂无内容，快来"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#0e9aff",
                                cursor: "pointer"
                              },
                              on: { click: _vm.setStatus }
                            },
                            [_vm._v("发起讨论")]
                          ),
                          _vm._v("吧")
                        ])
                      ]
                    )
                  ],
                  1
                )
          ]
        )
      : _vm.showEditor
      ? _c(
          "div",
          { staticClass: "note-text" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("el-input", {
              attrs: {
                type: "textarea",
                placeholder: "请输入主题",
                maxlength: "300",
                "show-word-limit": ""
              },
              model: {
                value: _vm.discussDetails.theme,
                callback: function($$v) {
                  _vm.$set(
                    _vm.discussDetails,
                    "theme",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "discussDetails.theme"
              }
            }),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("editor", {
              attrs: {
                height: "200px",
                toolMenus: _vm.editorMenus,
                onlyKey: _vm.discussId + "zlDiscuss"
              },
              model: {
                value: _vm.discussDetails.content,
                callback: function($$v) {
                  _vm.$set(
                    _vm.discussDetails,
                    "content",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "discussDetails.content"
              }
            }),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("el-switch", {
              attrs: { "active-value": 1, "inactive-value": 0 },
              model: {
                value: _vm.discussDetails.roofPlacement,
                callback: function($$v) {
                  _vm.$set(_vm.discussDetails, "roofPlacement", $$v)
                },
                expression: "discussDetails.roofPlacement"
              }
            }),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c("el-switch", {
              attrs: { "active-value": 0, "inactive-value": 1 },
              model: {
                value: _vm.discussDetails.anonymous,
                callback: function($$v) {
                  _vm.$set(_vm.discussDetails, "anonymous", $$v)
                },
                expression: "discussDetails.anonymous"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bottombtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.cancelEditor }
                  },
                  [_vm._v("返 回")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.addNote()
                      }
                    }
                  },
                  [_vm._v("保 存")]
                )
              ],
              1
            )
          ],
          1
        )
      : _vm.showDetails
      ? _c(
          "div",
          { staticClass: "note-show" },
          [
            _c(
              "div",
              { staticClass: "note-goback" },
              [
                _c("span"),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.cancelEditor }
                  },
                  [_vm._v("返 回")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("discussDetail", {
              attrs: { discussId: _vm.discussId, query: _vm.query },
              on: { getDiscussionToEdt: _vm.getDiscussionToEdt }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "note-text-p" }, [
      _c("i", [_vm._v("*")]),
      _c("span", [_vm._v("主题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "note-text-p" }, [
      _c("span", [_vm._v("内容")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "note-text-p" }, [
      _c("span", [_vm._v("是否置顶")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "note-text-p" }, [
      _c("span", [_vm._v("是否匿名")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-104c1562", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-104c1562","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/IT/components/zlDiscuss.vue
// module id = null
// module chunks = 